<script lang="ts" setup>
import {cx} from 'class-variance-authority'

withDefaults(
  defineProps<{
    class?: string
    guides?: boolean
    absolute?: boolean
  }>(),
  {
    guides: true,
    absolute: false,
  }
)
</script>

<template>
  <div class="relative w-screen">
    <section class="relative w-full px-0">
      <slot name="outer" />

      <div :class="cx('z-10 w-full', absolute ? 'absolute' : 'relative', $props.class)">
        <slot />
      </div>

      <div v-if="guides" class="pointer-events-none absolute left-0 top-0 z-0 h-full w-full">
        <div class="screen-guides z-0 flex h-full justify-between">
          <div class="h-full w-px bg-gray-200/75"></div>
          <div class="h-full w-px bg-gray-200/75"></div>
        </div>
      </div>
    </section>
  </div>
</template>
